import p from './device-manage.vue';

export default p;
